<template>
  <div>
    <template v-if="loading">
          <v-skeleton-loader
          class="card-loader mb-5"
          type="article"
          elevation="2"
        ></v-skeleton-loader>
        </template>
  <draggable :list="assets" handle=".handle" @end="sortList(true)" v-else>
    <transition-group>
      <v-list v-for="(item, index) in assets" :key="item.id" two-line class="text-left">
          <SortCourseMaterialListItem :item="item" :id="id" :index="index" />
        <v-divider v-if="index != assets.length - 1" :key="index"></v-divider>
      </v-list>
    </transition-group>
  </draggable>
</div>
</template>
<script>
import courseAPI from "@/api/course.js";
import Draggable from "vuedraggable";
import SortCourseMaterialListItem from "@/components/admin/course/SortCourseMaterialListItem";

export default {
  name: "SortCourseMaterial",
  components: {
    Draggable,
    SortCourseMaterialListItem
  },
  props: {
    assets: {
      type: Array,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data(){
    return {
      loading: false
    }
  },
  methods: {
    removeAsset(index, id) {
      this.assets.splice(index, 1);
      courseAPI.removeCourseMaterial(this.id, id).then(() => {});
    },
    sortList(andSave) {
      const list = [];
      this.assets.forEach(function(x) {
        list.push(x.id);
      });
      andSave ? this.saveSortOrder(list) : null;
    },
    saveSortOrder(list) {
      this.loading = true;
      courseAPI.updateSort(this.id, list).then(() => {
        this.loading = false;
      });
    }
  }
};
</script>